import React, { useMemo } from 'react';
import { Card, Col, Row, Typography, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import {
  getReportsByModule,
  filterReportsByPermissions,
} from '@/reports/registry/standardReports';
import { REPORT_MODULE_LABELS, type ReportModuleKey } from '@/reports/types';

const { Title, Text } = Typography;

type Props = {
  module: ReportModuleKey;
};

export const DomainReportsHubPage: React.FC<Props> = ({ module }) => {
  const user = useAuthStore((s) => s.user);
  const reports = useMemo(
    () =>
      filterReportsByPermissions(
        getReportsByModule(module),
        user?.permissions,
        user?.is_super_admin
      ),
    [module, user]
  );

  return (
    <div style={{ maxWidth: 960, margin: '0 auto', padding: 8 }}>
      <Title level={4} style={{ marginTop: 0 }}>
        {REPORT_MODULE_LABELS[module]} reports
      </Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        Standard registers for this module. See the{' '}
        <Link to="/reports">global reports catalog</Link> for cross-module search.
      </Text>
      <Row gutter={[12, 12]}>
        {reports.map((r) => (
          <Col xs={24} md={12} key={r.id}>
            <Link to={r.route} style={{ textDecoration: 'none', color: 'inherit' }}>
              <Card size="small" hoverable>
                <Text strong>{r.title}</Text>
                <br />
                <Text type="secondary" style={{ fontSize: 13 }}>
                  {r.description}
                </Text>
                <div style={{ marginTop: 8 }}>
                  <Tag>{r.kind}</Tag>
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
      {!reports.length && <Card>No reports available for your permissions.</Card>}
    </div>
  );
};

export default DomainReportsHubPage;
